import React, { useEffect, useState } from "react";
import api, { extractErrorMessage } from "@/lib/api";
import { Type, Save, RotateCcw } from "lucide-react";

export const FooterTextField = ({ value, defaultValue, onSaved }) => {
  const [text, setText] = useState(value || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setText(value || "");
  }, [value]);

  const save = async (next) => {
    setBusy(true);
    setError("");
    setSaved(false);
    try {
      await api.put("/settings", { footer_text: next });
      await onSaved();
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      setError(extractErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  const isDefault = (value || "") === defaultValue;
  const dirty = text !== (value || "");

  return (
    <div className="card p-5 space-y-3" data-testid="footer-text-box">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="overline flex items-center gap-2">
            <Type size={12} /> Texto do rodapé
          </div>
          <div className="text-xs text-[var(--text-secondary)] mt-1" data-testid="footer-text-status">
            {isDefault ? "Padrão do sistema" : "Personalizado"}
          </div>
        </div>
        <span
          className="text-[10px] uppercase tracking-widest px-2 py-1 border"
          style={{
            borderColor: isDefault ? "rgba(255,255,255,0.15)" : "#C9A84C",
            color: isDefault ? "var(--text-secondary)" : "#C9A84C",
          }}
        >
          {isDefault ? "Padrão" : "Custom"}
        </span>
      </div>
      <form
        className="flex gap-2 flex-wrap items-center"
        onSubmit={(e) => {
          e.preventDefault();
          save(text);
        }}
      >
        <input
          data-testid="footer-text-input"
          className="input-field flex-1 min-w-[260px]"
          value={text}
          maxLength={80}
          placeholder={defaultValue}
          onChange={(e) => setText(e.target.value)}
        />
        <button
          type="submit"
          data-testid="footer-text-save"
          className="btn-primary !py-2 !text-xs inline-flex items-center gap-1"
          disabled={busy || !dirty}
        >
          <Save size={13} /> {busy ? "Salvando..." : "Salvar"}
        </button>
        {!isDefault && (
          <button
            type="button"
            data-testid="footer-text-reset"
            className="btn-ghost !py-2 !text-xs inline-flex items-center gap-1"
            disabled={busy}
            onClick={() => save("")}
          >
            <RotateCcw size={13} /> Restaurar padrão
          </button>
        )}
      </form>
      <div className="flex items-center justify-between text-[11px] text-[var(--text-secondary)]">
        <span>Aparece entre as duas logos no rodapé de todos os PDFs. Até 80 caracteres.</span>
        <span data-testid="footer-text-count">{text.length}/80</span>
      </div>
      {saved && <div className="text-[11px] text-[#5AF78E]" data-testid="footer-text-saved">✓ Salvo</div>}
      {error && <div className="text-[11px] text-[#FF6B6B]" data-testid="footer-text-error">{error}</div>}
    </div>
  );
};
